import { cn } from '@/lib/utils'
import type { PageType } from '@/modules/common/consts'
import type { PropsWithChildren, ReactNode } from 'react'
import { ModuleHeader } from './module-header'

interface Props extends PropsWithChildren {
  className?: string

  title: ReactNode
  page?: PageType
  loading?: boolean

  headerContent?: ReactNode
  headerContentClassName?: string
}

export function ModuleWrapper({
  children,
  className,

  title,
  page,
  loading = false,

  headerContent,
  headerContentClassName,
}: Props) {
  return (
    <div className={cn('p-4', 'md:px-13 md:pt-8 md:pb-13', className)}>
      <ModuleHeader
        title={title}
        page={page}
        loading={loading}
        contentClassName={headerContentClassName}
      >
        {headerContent}
      </ModuleHeader>

      {children}
    </div>
  )
}
